import { api } from '../api';
import { Empty, ErrorNote, Loading, PageHead, useLoad } from '../components/ui';
import { ProblemsTable, type Problem } from './owner/Problems';

/** A teammate's own problems: its agents, its demo links, its tests. */
export default function MyProblems() {
  const { data, error, loading } = useLoad(() => api.get<{ problems: Problem[] }>('/api/my/problems'));
  return (
    <>
      <PageHead
        title="Problems"
        sub="What went wrong on your agents and demo links, and why. Your prospects only saw a plain sentence; the real reason is here. Kept for 30 days."
      />
      <ErrorNote error={error} />
      {loading && !data ? <Loading /> : !data?.problems.length ? <Empty>Nothing has gone wrong in the last 30 days.</Empty> : <ProblemsTable problems={data.problems} owner={false} />}
    </>
  );
}
